import React from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";

const FormRow = ({ label, full, delay }) => (
  <motion.div
    className={`col-md-${full ? "12" : "6"} mb-3`}
    initial={{ opacity: 0, y: 15 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay }}
  >
    <div className="d-flex align-items-center gap-2">
      <label style={{ width: 160, fontSize: 13 }}>{label}</label>

      <motion.select
        whileFocus={{ scale: 1.02 }}
        className="form-select form-select-sm"
      >
        <option>---- Select ----</option>
      </motion.select>
    </div>
  </motion.div>
);

export default function LocalizationForm() {
  return (
    <motion.div
      className=" card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Localization Settings
      </motion.h5>

      {/* CARD */}
      <motion.div
        className="card shadow-sm border-0 p-3"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15 }}
      >
        {/* SECTION 1 */}
        <motion.h6
          className="mb-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          Localization
        </motion.h6>

        <div className="row">
          {[
            "Language",
            "Timezone",
            "Date Format",
            "Time Format",
            "Financial Year",
            "Starting Month",
          ].map((label, i) => (
            <FormRow key={label} label={label} delay={i * 0.05} />
          ))}
        </div>

        <hr />

        {/* SECTION 2 */}
        <motion.h6
          className="mb-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Currency Information
        </motion.h6>

        <div className="row">
          {[
            "Currency",
            "Currency Symbol",
            "Currency Position",
            "Decimal Separator",
            "Thousand Separator",
          ].map((label, i) => (
            <FormRow key={label} label={label} delay={0.1 + i * 0.05} />
          ))}
        </div>

        <hr />

        {/* SECTION 3 */}
        <motion.h6
          className="mb-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          Country Settings
        </motion.h6>

        <div className="row">
          <FormRow label="Countries Restriction" full delay={0.2} />
        </div>

        <hr />

        {/* SECTION 4 */}
        <motion.h6
          className="mb-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          File Settings
        </motion.h6>

        <div className="row">
          <FormRow label="Allowed Files" delay={0.25} />

          <motion.div
            className="col-md-6 mb-3"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <div className="d-flex align-items-center gap-2">
              <label style={{ width: 160, fontSize: 13 }}>
                Max File Size
              </label>

              <motion.input
                whileFocus={{ scale: 1.02 }}
                className="form-control form-control-sm"
                defaultValue="5000 MB"
              />
            </div>
          </motion.div>
        </div>

        {/* BUTTONS */}
        <motion.div
          className="d-flex justify-content-end gap-2 mt-3"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-sm btn-outline-danger"
          >
            Cancel
          </motion.button>

          <motion.button
            whileTap={{ scale: 0.9 }}
            className="btn btn-sm btn-outline-primary"
          >
            Save
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}